// Team preferences data structure interfaces
export interface PreferenceItem {
  status?: string
  description?: string
  message?: string
}

export interface TeamPreferences {
  'Apply link'?: PreferenceItem
  'Property uploader'?: PreferenceItem
  Autoresponder?: PreferenceItem
  'Utility connection provider'?: PreferenceItem
  'Website notifications'?: PreferenceItem
  'Email notifications'?: PreferenceItem
  'Number of invited team members'?: PreferenceItem
  'Property Management System'?: PreferenceItem
  Bundles?: PreferenceItem
}

export interface TeamPreferencesData {
  preferences?: TeamPreferences
  // Add other properties that might exist on preferencesData
  [key: string]: any
}

// Type-safe helper to get preference item
export const getPreferenceItem = (
  preferences: TeamPreferences | undefined,
  key: keyof TeamPreferences,
): PreferenceItem | undefined => {
  return preferences?.[key]
}

// Type-safe helper to get bundle description
export const getBundleDescription = (
  preferences: TeamPreferences | undefined,
): string | undefined => {
  return preferences?.['Bundles']?.description
}
